import { useEffect, useMemo, useRef, useState } from "react";

import { KONVA_HEIGHT, KONVA_WIDTH } from "./utils";

const useCreateImageLayer = (
  keyFrame: string,
  setKeyframeLoaded?: (state: boolean) => void,
  view = false
) => {
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState<HTMLImageElement>();
  const [imageSource, setImageSource] = useState("");
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [skale, setSkale] = useState({ scaleX: 1, scaleY: 1 });
  const [skaleFactor, setSkaleFactor] = useState(1);

  const imageRef = useRef<any>(null);

  const { scaleX, scaleY } = skale;

  const resetImageState = () => {
    setImage(undefined);

    setSize({ width: 0, height: 0 });

    setSkale({ scaleX: 1, scaleY: 1 });

    setSkaleFactor(1);
  };

  const setImagePath = () => {
    if (keyFrame) {
      setLoading(true);

      setKeyframeLoaded?.(false);

      resetImageState();

      setImageSource(keyFrame);
    } else {
      resetImageState();

      setImageSource("");

      setLoading(false);

      setKeyframeLoaded?.(false);
    }
  };

  const handleRetry = () => setImagePath();

  const onload = function () {
    setSize({
      width: imageElement.width,
      height: imageElement.height,
    });

    const skaleFactor = imageElement.width / imageElement.height;

    let scaleX = imageElement.width / (KONVA_HEIGHT * skaleFactor);
    let scaleY = imageElement.height / KONVA_HEIGHT;

    if (view) {
      scaleX = imageElement.width / KONVA_WIDTH;

      scaleY = imageElement.height / KONVA_WIDTH / skaleFactor;
    }

    setSkale({ scaleX, scaleY });

    setSkaleFactor(skaleFactor);

    setImage(imageElement);

    imageRef.current = imageElement;

    setLoading(false);

    setKeyframeLoaded?.(true);
  };

  useEffect(() => {
    setImagePath();
  }, []);

  const imageElement = useMemo(() => {
    const element = new window.Image();

    element.src = imageSource;

    element.onload = onload;

    element.onerror = () => {
      setLoading(false);

      resetImageState();

      setKeyframeLoaded?.(false);
    };

    return element;
  }, [imageSource]);

  const widthScale =
    size.width && size.height ? size.width / KONVA_HEIGHT : scaleX;
  const heightScale =
    size.height && size.width ? size.height / KONVA_HEIGHT : scaleY;

  return {
    image,
    size,
    imageRef,
    scaleX: widthScale,
    scaleY: heightScale,
    skaleFactor,
    loading,
    handleRetry,
  };
};

export default useCreateImageLayer;
